import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./WikiNavBar.scss";

interface NavItem {
  label: string;
  path: string;
}

const NAV_ITEMS: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "角色", path: "/role" },
  { label: "军备", path: "/armament" },
  { label: "阵营", path: "/camp" },
  { label: "事件", path: "/event" },
  { label: "地图", path: "/map" },
  { label: "宝藏", path: "/anecdote" },
  { label: "记录", path: "/record" },
  { label: "探索", path: "/explore" },
];

const WikiNavBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="wiki-navbar">
      <div className="wiki-navbar-inner">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.path}
            className={`wiki-navbar-item ${location.pathname === item.path || (item.path !== "/" && location.pathname.startsWith(item.path + "/")) ? "active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default WikiNavBar;
